import React, { FC } from "react";
import { Row, Col } from "antd";
import "./item.scss";

type TItemsProps = {
  left?: number;
  right?: number;
  leftClass?: string;
  rightClass?: string;
  name?: string;
  value?: string;
  subValue?:string;
  containerClass?: string;
  keycolor?:string;
};

const MemberItems: FC<any> = ({
  left,
  right,
  leftClass,
  rightClass,
  name,
  value,
  subValue,
  containerClass,
  keycolor = ""
}: TItemsProps) => {
  return (
    <Row className={`${containerClass} ${name === "Responsible Party" ? "responsible_party" : ""}`} style={{alignItems: "center"}}>
      <Col span={left} className={leftClass}>
        <p className={`member-key ${keycolor}`} style={{ marginBottom: 24 }}>
          {name}
        </p>
      </Col>
      <Col span={right} className={rightClass}>
        <p className="member-value" style={{ marginBottom: 24 }}>
          {value ? value : "--"}{subValue?subValue:null}
        </p>
      </Col>
    </Row>
  );
};

export default MemberItems;
